module.exports = __webpack_public_path__ + "img/16l012-02.91c0ec69.jpg";